import React from 'react';
import { create } from 'zustand';
import { getCurrentWebsiteConfig, getCurrentWebsite, WebsiteConfig } from '../config/websites';

interface WebsiteState {
    config: WebsiteConfig;
    getAsset: (path: string) => string;
}

export const useWebsiteStore = create<WebsiteState>((set, get) => ({
    config: getCurrentWebsiteConfig(),

    getAsset: (path: string) => {
        const { config } = get();
        // Get the current website name from the config, not the display name
        const websiteName = getCurrentWebsite();
        return path.replace('/websites/placeholder/', `/websites/${websiteName}/`);
    },
}));

export function useWebsite() {
    const store = useWebsiteStore();
    return store;
}

export function WebsiteProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    return <>{children}</>;
}
